import React from "react";
import { Modal, Button, ListGroup } from "react-bootstrap";
import { useNotifications } from "../contexts/NotificationContext";
import { useI18n } from "../i18n";

interface NotificationModalProps {
  show: boolean;
  onHide: () => void;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  show,
  onHide,
}) => {
  const { notifications, deleteNotification } = useNotifications();
  const { t } = useI18n();

  const handleDelete = async (id: number) => {
    await deleteNotification(id);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-bell"></i> {t("notifications.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "500px", overflowY: "auto" }}>
        {notifications.length === 0 ? (
          <p className="text-center text-muted">{t("notifications.noNotifications")}</p>
        ) : (
          <ListGroup variant="flush">
            {notifications.map((notification) => (
              <ListGroup.Item
                key={notification.id}
                className={!notification.is_read ? "bg-light" : ""}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <p className="mb-1">{notification.message}</p>
                    <small className="text-muted">
                      {new Date(notification.created_at).toLocaleString()}
                    </small>
                  </div>
                  {!notification.is_read && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(notification.id)}
                    >
                      {t("notifications.dismiss")}
                    </Button>
                  )}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NotificationModal;
